var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMap = function SvgMap(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 848 556",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "map_svg__a",
    width: 848,
    height: 556,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h847.147v555.685H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#map_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 424.936,
    cy: 277.842,
    r: 495.758
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M424.935 874.689c329.63 0 596.845-267.217 596.845-596.847S754.565-319.005 424.935-319.005c-329.629 0-596.846 267.218-596.846 596.847 0 329.63 267.217 596.847 596.846 596.847M-46.544 6.905 920.48 442.347l-47.338 105.126-434.953-195.856-219.202 482.882-104.982-47.656L333.061 304.28-93.881 112.031z",
    clipRule: "evenodd"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMap);
export { ForwardRef as Icon };
export default "img/location/map.a3d1233.svg";